
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppBaidu";
import {
  IMapContainer,
  IOverlayParameter,
  IHeatParameter,
  IOverlayClusterParameter,
  IOverlayDelete,
  ILayerConfig,
  IPointGeometry,
  ICenterLevel,
  IFindParameter,
  IResult,
  IDistrictParameter,
  IStreetParameter,
  IRouteParameter,
  IHeatImageParameter,
  IGeometrySearchParameter,
  ICustomTip,
  ISelectRouteParam,
  ISelectRouteResult,
  IDrawOverlays,
  ISelectRouteHitTest,
  IDefinitionParameter,
  ITrackParameter,
  ISumoConnectInfo,
  IPassagewaysParam,
  ISignalPhaseInfo,
  IPopUpTemplate,
  IMapControlParam,
  IPOILocalSearchParameter,
} from "@/types/map";
@Component({
  name: "MapAppBaidu",
})
export default class MapContainerArcgis extends Vue implements IMapContainer {
  private mapApp!: MapApp;

  private mapId: string = "divBMap" + (Math.random() * 10000).toFixed(0);
  //地图配置
  @Prop({ type: Object }) readonly mapConfig!: Object;

  @Emit("map-loaded")
  async mounted() {
    this.mapApp = new MapApp();
    await this.mapApp.initialize(this.mapConfig, this.mapId);
    this.mapApp.showGisDeviceInfo = this.showGisDeviceInfo;
    this.mapApp.mouseOverMarker = this.mouseGisDeviceInfo;
    this.mapApp.mapClick = this.mapClick;
    this.mapApp.mapTouch = this.mapTouch;
  }

  @Emit("layer-loaded")
  public layerLoaded() {}

  @Emit("map-click")
  public mapClick(point: object) {}

  @Emit("map-touch")
  public mapTouch(point: object) {}

  @Emit("marker-click")
  public showGisDeviceInfo(type: string, id: string, detail: any) {}

  @Emit("marker-mouse")
  public mouseGisDeviceInfo(event: any, type: string, id: string, detail: any) {}

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    return await this.mapApp.addOverlays(params);
  }
  public async showODData(params: any) {
    this.mapApp.showODData(params);
  }
  public hideMigrateChart(params?: any) {
    this.mapApp.hideMigrateChart(params);
  }
  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    return await this.mapApp.addOverlaysCluster(params);
  }
  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    return this.mapApp.addHeatMap(params);
  }
  public deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    return this.mapApp.deleteOverlays(params);
  }
  public deleteOverlaysCluster(params: IOverlayDelete) {
    this.mapApp.deleteOverlaysCluster(params);
  }
  public deleteAllOverlays() {
    this.mapApp.deleteAllOverlays();
  }
  public deleteAllOverlaysCluster() {
    this.mapApp.deleteAllOverlaysCluster();
  }
  public deleteHeatMap(params: ILayerConfig) {
    this.mapApp.deleteHeatMap(params);
  }
  public showLayer(params: ILayerConfig) {
    this.mapApp.showLayer(params);
  }
  public hideLayer(params: ILayerConfig) {
    this.mapApp.hideLayer(params);
  }
  public setMapCenter(params: IPointGeometry) {
    this.mapApp.setMapCenter(params);
  }
  public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
    await this.mapApp.setMapCenterAndLevel(params);
  }
  public showJurisdiction() {
    this.mapApp.showJurisdiction();
  }
  public hideJurisdiction() {
    this.mapApp.hideJurisdiction();
  }
  public showDistrictMask(param: IDistrictParameter) {}
  public hideDistrictMask() {}
  public findFeature(params: IFindParameter): Promise<IResult> {
    return this.mapApp.findFeature(params);
  }
  public showRoad() {}

  public async addTileLayer(): Promise<IResult> {
    return this.mapApp.addTileLayer();
  }
  public async deleteTileLayer(): Promise<IResult> {
    return this.mapApp.deleteTileLayer();
  }

  public hideRoad() {}
  public showStreet() {}
  public hideStreet() {}
  public locateStreet(param: IStreetParameter) {}
  public setMapStyle(param: string) {
    this.mapApp.setMapStyle(param);
  }
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearRouteSearch() {}
  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}
  public async addDrawLayer(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearDrawLayer(params: ILayerConfig) {}
  public addHeatImage(params: IHeatImageParameter) {}
  public deleteHeatImage() {}
  public showMigrateChart(params: any) {}
  public showBarChart(params: any) {}
  public hideBarChart() {}
  public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
    return await this.mapApp.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    this.mapApp.clearGeometrySearch();
  }
  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public showCustomTip(params: ICustomTip) {
    this.mapApp.showCustomTip(params);
  }
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    return await this.mapApp.startDrawOverlays(params);
  }
  public async stopDrawOverlays(): Promise<void> {
    return await this.mapApp.stopDrawOverlays();
  }
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
    return await this.mapApp.deleteDrawOverlays(params);
  }
  public async getDrawOverlays(): Promise<IResult> {
    return await this.mapApp.getDrawOverlays();
  }
  public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {}
  public async startTrackPlay(params: ITrackParameter): Promise<void> {}

  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.getOverlays(params);
  }

  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async setMapFocus(focusInfo: { type: string; id: string; scaleFactor?: number }): Promise<IResult> {
    return { status: -2, message: "no function" };
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    return { status: -2, message: "no function" };
  }

  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async showPopup(params: IPopUpTemplate) {}
  public toggleWidget(params: string[]) {
    this.mapApp.toggleWidget(params);
  }

  public async addPointCollection(params: IOverlayParameter): Promise<IResult> {
    if (this.mapApp.addPointCollection) {
      return await this.mapApp.addPointCollection(params);
    }
    return { status: 0, message: "no function" };
  }
  public async deletePointCollection(params: IOverlayDelete): Promise<IResult> {
    if (this.mapApp.deletePointCollection) {
      return await this.mapApp.deletePointCollection(params);
    }
    return { status: 0, message: "no function" };
  }
  public async findPointCollection(params: IFindParameter): Promise<IResult> {
    if (this.mapApp.findPointCollection) {
      return await this.mapApp.findPointCollection(params);
    }
    return { status: 0, message: "no function" };
  }

  public async showOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.showOverlays(params);
  }
  public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.hideOverlays(params);
  }

  public async closePopup() {
    this.mapApp.closePopup();
  }

  public async setMapControl(params: IMapControlParam) {
    return await this.mapApp.setMapControl(params);
  }

  public async localSearch(params: IPOILocalSearchParameter): Promise<IResult> {
    return await this.mapApp.localSearch(params);
  }
}
